import {styled, Tooltip, tooltipClasses, TooltipProps} from "@mui/material";

export const WhiteTooltip = styled(({className, ...props}: TooltipProps) => (
    <Tooltip {...props} arrow placement="top" classes={{popper: className}}>
        {props.children}
    </Tooltip>
))(({theme}) => ({
    zIndex: 10001,
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "white",
        color: "black",
        boxShadow: theme.shadows[1],
        border: "1px solid white",
        borderRadius: "8px"
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "white",
    },
}));
